<template>
  <div>
    <template v-if="showForm">
      <ra-card v-if="action === 'edit'" class="authx-form mb-2">
        <template slot="header">
          <div class="heading mb-0">
            <h5>Security</h5>
            <p>
              {{
                newClientSecret
                  ? "Client Secret should be saved as it won’t be viewed after you leave this page"
                  : "Lost Client Secret? You can reset it here."
              }}
            </p>
          </div>
          <div>
            <div v-if="newClientSecret" class="client-secret">
              <p>{{ newClientSecret }}</p>
              <span
                class="copy"
                v-clipboard:copy="newClientSecret"
                @click="copyNewSecret"
                ><i class="ra-icon--copy"></i
              ></span>
            </div>
            <template v-else>
              <el-button
                v-if="userCan('authx', 'app.resetoauthsecret')"
                type="primary"
                plain
                :loading="resetting"
                @click="resetClientSecret"
                >Reset</el-button
              >
            </template>
          </div>
        </template>
      </ra-card>
      <ra-card class="authx-form" v-loading="loading">
        <template slot="header">
          <div class="heading">
            <h5>Configure Onboarding Page</h5>
            <p>
              Create a beautiful login/signup page where you can onboard your
              users.
            </p>
          </div>
          <div
            v-if="appId"
            class="w-20 is-flex is-justify-between is-align-center mb-3"
          >
            <application-status-change
              :disabled="!userCan('authx', 'app.updatestatus')"
              :app-name="form.name"
              :app-id="appId"
              :app-status.sync="is_enabled"
              :show-text="true"
              @success="loadApp(false)"
            />
          </div>
        </template>
        <template slot="content">
          <el-form :model="form" label-position="top" ref="authXForm">
            <el-row type="flex" :gutter="80" class="authx-form-section">
              <el-col :md="8" :lg="8">
                <div class="rd-form--section">
                  <h6>General</h6>
                </div>
              </el-col>
              <el-col :md="16" :lg="16">
                <el-row type="flex" :gutter="40" class="flex-wrap">
                  <el-col :span="24">
                    <el-form-item
                      label="Name"
                      prop="name"
                      :rules="inputField()"
                    >
                      <el-input v-model="form.name" placeholder="Enter name" />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row type="flex" :gutter="20">
                  <el-col :md="24" :lg="24">
                    <el-form-item label="Description" prop="address">
                      <el-input
                        v-model="form.description"
                        type="textarea"
                        rows="5"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <el-row type="flex" :gutter="80" class="authx-form-section">
              <el-col :md="8" :lg="8">
                <div class="rd-form--section">
                  <h6>Customization</h6>
                </div>
              </el-col>
              <el-col :md="16" :lg="16">
                <el-row type="flex" :gutter="20" class="flex-wrap">
                  <el-col :md="5">
                    <el-form-item>
                      <template slot="label">
                        <el-tooltip
                          effect="dark"
                          content="Image size should be 1MB or less"
                          placement="top-start"
                        >
                          <p class="logo-label">
                            Logo <i class="ra-icon--alert-octagon"></i>
                          </p>
                        </el-tooltip>
                      </template>
                      <ra-image-upload
                        :image-url="form.customization.company_logo"
                        :image-size="80"
                        :image-text="'logo'"
                        :style="{
                          alignItems: 'flex-start',
                          lineHeight: '1'
                        }"
                        @selected="uploadLogo"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :md="19">
                    <el-row type="flex" class="flex-wrap">
                      <el-col :span="24">
                        <el-form-item
                          label="Company Name"
                          prop="customization.company_name"
                          :rules="inputField()"
                        >
                          <el-input
                            v-model="form.customization.company_name"
                            placeholder="Enter company name"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row type="flex" :gutter="20">
                      <el-col :md="12" :lg="12">
                        <el-form-item
                          label="Primary Colour"
                          prop="customization.meta_data.primary_color"
                          :rules="inputField()"
                        >
                          <el-color-picker
                            v-model="form.customization.meta_data.primary_color"
                          ></el-color-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :md="12" :lg="12">
                        <el-form-item
                          label="Secondary Colour"
                          prop="customization.meta_data.secondary_color"
                        >
                          <el-color-picker
                            v-model="
                              form.customization.meta_data.secondary_color
                            "
                            show-alpha
                          ></el-color-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              :gutter="80"
              v-if="!hideTemporarily"
              class="authx-form-section"
            >
              <el-col :md="8" :lg="8">
                <div class="rd-form--section">
                  <h6>Verification Type</h6>
                </div>
              </el-col>
              <el-col :md="16" :lg="16">
                <el-row type="flex" :gutter="40" class="flex-wrap">
                  <el-col :span="24">
                    <el-form-item
                      prop="verification_type.verification_type_id"
                      :rules="inputField()"
                    >
                      <el-radio
                        v-for="(vt, index) in verificationTypes"
                        :key="index"
                        :label="vt.id"
                        class="mr-0"
                        border
                        :value="vt.id"
                        v-model="form.verification_type.verification_type_id"
                        >{{ vt.name }}</el-radio
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <el-row type="flex" :gutter="80" class="authx-form-section">
              <el-col :md="8" :lg="8">
                <div class="rd-form--section">
                  <h6>Verification</h6>
                </div>
              </el-col>
              <el-col :md="16" :lg="16">
                <el-row type="flex">
                  <el-col :span="24">
                    <div class="compulsory_fields">
                      <h6>Identifier</h6>
                      <el-row
                        type="flex"
                        :gutter="20"
                        class="flex-wrap"
                        align="middle"
                      >
                        <el-col :md="18" :lg="18">
                          <el-form-item
                            prop="user_auth_types.password.config.username_label"
                            :rules="inputField()"
                          >
                            <el-input
                              v-model="
                                form.user_auth_types.password.config
                                  .username_label
                              "
                              placeholder="Enter label name"
                              :disabled="applicationCode.length > 0"
                            />
                          </el-form-item>
                        </el-col>

                        <el-col :md="6" :lg="6">
                          <el-form-item
                            prop="user_auth_types.password.config.username_field_type_id"
                            :rules="inputField()"
                          >
                            <el-select
                              v-model="
                                form.user_auth_types.password.config
                                  .username_field_type_id
                              "
                              clearable
                              placeholder="Select Type"
                              :disabled="applicationCode.length > 0"
                            >
                              <el-option
                                v-for="(ft, index) in fieldTypesText"
                                :key="index"
                                :label="ft.label"
                                :value="ft.id"
                              />
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>

                    <div class="compulsory_fields">
                      <h6>Password</h6>
                      <el-row
                        type="flex"
                        :gutter="20"
                        class="flex-wrap"
                        align="middle"
                      >
                        <el-col :md="18" :lg="18">
                          <el-form-item
                            prop="user_auth_types.password.config.password_label"
                            :rules="inputField()"
                          >
                            <el-input
                              v-model="
                                form.user_auth_types.password.config
                                  .password_label
                              "
                              placeholder="Enter password"
                              :disabled="applicationCode.length > 0"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row
                        type="flex"
                        :gutter="20"
                        class="flex-wrap mt-2"
                        align="middle"
                      >
                        <el-col :md="5" :lg="5">
                          <el-form-item label="Min Length">
                            <el-input
                              v-model="
                                form.user_auth_types.password.config
                                  .password_validation.min_length
                              "
                              type="text"
                              :min="8"
                              placeholder="Enter password length name"
                              :disabled="applicationCode.length > 0"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :md="19" :lg="19">
                          <el-form-item label="Characters">
                            <div class="is-flex">
                              <el-checkbox
                                v-model="
                                  form.user_auth_types.password.config
                                    .password_validation.include_uppercase
                                "
                                label="uppercase"
                                :disabled="applicationCode.length > 0"
                                >Uppercase</el-checkbox
                              >
                              <el-checkbox
                                v-model="
                                  form.user_auth_types.password.config
                                    .password_validation.include_numbers
                                "
                                label="number"
                                :disabled="applicationCode.length > 0"
                                >Number</el-checkbox
                              >
                              <el-checkbox
                                v-model="
                                  form.user_auth_types.password.config
                                    .password_validation.include_special
                                "
                                label="special"
                                :disabled="applicationCode.length > 0"
                                >Special Character</el-checkbox
                              >
                            </div>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row
                        type="flex"
                        :gutter="20"
                        class="flex-wrap mt-2"
                        align="middle"
                      >
                        <el-col :md="6" :lg="12">
                          <el-form-item label="">
                            <div class="social-logo" slot="label">
                              <img :src="getImage('google.svg')" alt="Google" />
                              <span>Google Authentication</span>
                            </div>
                            <el-switch
                              v-model="googleAuth"
                              :active-value="true"
                              :inactive-value="false"
                              :disabled="applicationCode.length > 0"
                            />
                          </el-form-item>
                        </el-col>

                        <el-col :md="6" :lg="12">
                          <el-form-item>
                            <div class="social-logo" slot="label">
                              <img
                                :src="getImage('facebook.svg')"
                                alt="Facebook"
                              />
                              <span>Facebook Authentication</span>
                            </div>
                            <el-switch
                              v-model="facebookAuth"
                              :active-value="true"
                              :inactive-value="false"
                              :disabled="applicationCode.length > 0"
                            />
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <el-row type="flex" :gutter="80" class="authx-form-section">
              <el-col :md="8" :lg="8">
                <div class="rd-form--section">
                  <h6>Additional Fields</h6>
                  <br />
                  <label class="el-form-item__label"
                    >You must add minimum of one additional field</label
                  >
                </div>
              </el-col>
              <el-col :md="16" :lg="16">
                <el-row type="flex" v-if="form.user_data_fields.length">
                  <el-col :span="24">
                    <el-table
                      :data="(data = form.user_data_fields)"
                      empty-text="No Fields"
                      class="fadeIn"
                    >
                      <el-table-column width="40" v-if="!hideTemporarily">
                        <template slot-scope="scope">
                          <el-form-item>
                            <el-checkbox v-model="scope.row.selected" />
                          </el-form-item>
                        </template>
                      </el-table-column>

                      <el-table-column width="240">
                        <template slot="header">
                          <span>
                            Label
                          </span>
                        </template>
                        <template slot-scope="scope">
                          <el-form-item
                            :prop="`user_data_fields.${scope.$index}.label`"
                            :rules="inputField()"
                          >
                            <el-input
                              size="medium"
                              placeholder="Label"
                              v-model="scope.row.label"
                              :readonly="scope.row.readonly"
                              :disabled="applicationCode.length > 0"
                            />
                          </el-form-item>
                        </template>
                      </el-table-column>

                      <el-table-column width="140">
                        <template slot="header">
                          <span>
                            Type
                          </span>
                        </template>
                        <template slot-scope="scope">
                          <el-form-item
                            :prop="
                              `user_data_fields.${scope.$index}.field_type_id`
                            "
                            :rules="inputField()"
                          >
                            <el-select
                              size="medium"
                              :disabled="applicationCode.length > 0"
                              v-model="scope.row.field_type_id"
                              clearable
                              placeholder="Select Type"
                              @change="editOptions(scope.$index)"
                            >
                              <el-option
                                v-for="(ft, index) in fieldTypes"
                                :key="index"
                                :label="ft.label"
                                :value="ft.id"
                              />
                            </el-select>
                          </el-form-item>
                        </template>
                      </el-table-column>

                      <el-table-column width="100">
                        <template slot="header">
                          <span>
                            Required
                          </span>
                        </template>
                        <template slot-scope="scope">
                          <el-form-item>
                            <el-switch
                              v-model="scope.row.is_required"
                              :active-value="1"
                              :inactive-value="0"
                              :disabled="applicationCode.length > 0"
                            />
                          </el-form-item>
                        </template>
                      </el-table-column>

                      <el-table-column>
                        <template slot="header">
                          <span>
                            Autofill
                          </span>
                        </template>
                        <template slot-scope="scope">
                          <el-form-item>
                            <el-switch
                              disabled
                              v-model="scope.row.allow_autofill"
                              :active-value="1"
                              :inactive-value="0"
                            />
                          </el-form-item>
                        </template>
                      </el-table-column>

                      <el-table-column align="right">
                        <template slot-scope="scope">
                          <el-form-item>
                            <div class="field__action">
                              <div
                                v-if="currentField(scope.row.field_type_id)"
                                class="field__edit"
                                @click="editField(scope.$index)"
                              >
                                <span><i class="el-icon-edit"></i></span>
                              </div>
                              <div
                                v-if="applicationCode.length === 0"
                                class="field__remove"
                                @click="removeField(scope.$index)"
                              >
                                <span><i class="el-icon-close"></i></span>
                              </div>
                            </div>
                          </el-form-item>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
                <el-row type="flex" v-if="applicationCode.length === 0">
                  <el-col :span="24">
                    <div class="field__add" @click="addField">
                      <i class="ra-icon--plus-circle"></i>
                      <p>Add New Field</p>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <el-row type="flex" :gutter="80" class="authx-form-section">
              <el-col :md="8" :lg="8">
                <div class="rd-form--section">
                  <h6>Development</h6>
                </div>
              </el-col>
              <el-col :md="16" :lg="16">
                <el-row type="flex" class="flex-wrap mb-1">
                  <el-col :span="24">
                    <el-form-item
                      label="Domain (Ex: www.testdomain.com or testdomain.com)"
                      prop="development.domain"
                      :rules="domainField()"
                    >
                      <el-input
                        v-model="form.development.domain"
                        placeholder="Enter company domain name"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row
                  v-if="form.development.oauth"
                  type="flex"
                  class="flex-wrap mb-1"
                >
                  <el-col :span="18">
                    <el-form-item
                      label="Redirect Url (Ex: http(s)://testdomain.com)"
                      prop="development.oauth.redirect_uri"
                      :rules="urlField()"
                    >
                      <el-input
                        v-model="form.development.oauth.redirect_uri"
                        placeholder="Enter a valid redirect URL"
                      />
                    </el-form-item>
                  </el-col>

                  <el-col :span="1"></el-col>

                  <el-col :span="5">
                    <el-form-item
                      label="Single Page App"
                      prop="development.oauth.is_spa"
                      :rules="inputField()"
                    >
                      <el-switch
                        v-model="form.development.oauth.is_spa"
                        :active-value="true"
                        :inactive-value="false"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" class="flex-wrap mb-1">
                  <el-col :span="24">
                    <div class="field__note">
                      <p>
                        For testing in local environment, set the value of
                        domain and redirect url as
                      </p>
                      <pre>
                        <p>Domain - <strong>localhost</strong></p>
                        <p>Redirect URL - <strong>http://localhost:[PORT_NUMBER]/[REDIRECT_ROUTE]</strong></p>
                      </pre>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <el-row type="flex" :gutter="80" class="authx-form-section">
              <el-col :md="8" :lg="8">
                <div class="rd-form--section">
                  <h6>Authentication</h6>
                </div>
              </el-col>
              <el-col :md="16" :lg="16">
                <el-row type="flex" :gutter="40" class="flex-wrap mb-1">
                  <el-col :md="6" :lg="6">
                    <el-form-item
                      label="2FA for Signup"
                      prop="auth.allow_2fa_signup"
                      :rules="inputField()"
                    >
                      <el-switch
                        v-model="form.auth.allow_2fa_signup"
                        :active-value="1"
                        :inactive-value="0"
                        disabled
                      />
                    </el-form-item>
                  </el-col>

                  <el-col :md="6" :lg="6">
                    <el-form-item
                      label="2FA for Login"
                      prop="auth.allow_2fa_login"
                      :rules="inputField()"
                    >
                      <el-switch
                        v-model="form.auth.allow_2fa_login"
                        :active-value="1"
                        :inactive-value="0"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <el-row
              ref="footer"
              type="flex"
              :gutter="80"
              class="authx-form-section"
            >
              <el-col :md="8" :lg="8"></el-col>
              <el-col :md="16" :lg="16">
                <el-row type="flex" :gutter="40" class="flex-wrap mb-1">
                  <el-col :span="24">
                    <div v-if="applicationCode" class="save-info">
                      <p>
                        <span>Preview - </span>This allows you see your
                        configurations in a read-only mode.
                      </p>
                      <p>
                        <span>Live Test - </span>This allows you see and
                        interact with our configurations without saving.
                      </p>
                      <p>
                        <span>Save - </span>This would permanently save all the
                        changes you've made.
                      </p>
                    </div>
                    <div class="is-flex is-justify-end">
                      <template v-if="applicationCode">
                        <el-button type="primary" plain @click="preview('ui')">
                          Preview
                        </el-button>
                        <el-button
                          type="primary"
                          plain
                          @click="preview('sandbox')"
                          :loading="previewing"
                        >
                          Live Test
                        </el-button>
                      </template>
                      <el-button
                        v-if="userCan('authx', 'app.updatedata')"
                        type="primary"
                        :disabled="!formEdited"
                        :loading="saving"
                        @click="save"
                        >Save</el-button
                      >
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </ra-card>
      <el-dialog
        :visible.sync="showEditFieldOptions"
        @close="showEditFieldOptions = false"
        width="40%"
      >
        <template slot="title">
          <h6 class="title">Field Options</h6>
        </template>
        <el-form :model="field" label-position="top" ref="fund">
          <el-row type="flex">
            <el-col :span="24">
              <el-form-item label="" prop="options" :rules="inputField()">
                <el-input
                  v-model="field.options"
                  type="text"
                  placeholder="Enter options separated by comma (Option 1,Option 2)"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="24">
              <el-button
                size="medium"
                class="w-100"
                type="primary"
                :disabled="!field.options || applicationCode.length > 0"
                @click="saveOptions"
                >Save</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
    </template>
    <auth-x-widget-preview
      v-if="showWidgetPreview"
      :show.sync="showWidgetPreview"
      :app-data="appDataPreview"
      :app-code="applicationCode"
    />
  </div>
</template>

<script>
import ApplicationStatusChange from "@/components/Products/AuthX/Applications/Actions/ApplicationStatusChange";
import apiConstants from "@/apiConstants";

import { verificationTypes, fieldTypes } from "@/lib/utils";
import { defaultForm } from "./form";
import * as mutations from "@/store/mutation-types";
import RaImageUpload from "@/components/Global/RaImageUpload";
import AuthXWidgetPreview from "@/components/Products/AuthX/Widget/AuthXWidgetPreview.vue";

export default {
  name: "AuthXForm",
  components: {
    AuthXWidgetPreview,
    RaImageUpload,
    ApplicationStatusChange
  },
  props: {
    showForm: {
      type: Boolean,
      default: true
    },
    action: {
      type: String,
      default: "add"
    }
  },

  data() {
    return {
      hideTemporarily: true,
      active: apiConstants.GLOBAL_STATUS.ACTIVE,
      inActive: apiConstants.GLOBAL_STATUS.INACTIVE,
      is_enabled: apiConstants.GLOBAL_STATUS.ACTIVE,
      activeTab: "create",
      form: defaultForm(),
      company_logo_file: "",
      formEdited: false,
      verificationTypes: [],
      fieldTypes: [],
      fieldTypesText: [],
      fieldTypesWithOptions: [],
      showEditFieldOptions: false,
      field: {
        index: null,
        options: ""
      },
      appDataPreview: {},
      showWidgetPreview: false,
      loading: false,
      textFieldType: apiConstants.TEXT_TYPE_IDENTIFIER,
      collectionType: apiConstants.COLLECTION_TYPE_IDENTIFIER,
      appId: "",
      applicationCode: "",
      previewLoading: false,
      googleAuth: 0,
      facebookAuth: 0,
      previewing: false,
      saving: false,
      newClientSecret: "",
      resetting: false,
      appData: {},
      widgetData: {},
      domainData: {}
    };
  },

  methods: {
    onCopy() {
      this.$message({
        message: `Copied`,
        type: "success"
      });
    },

    addField() {
      this.form.user_data_fields.push({
        field_type_id: 1,
        label: "",
        name: "",
        hint: "",
        is_required: true,
        allow_autofill: false,
        meta_data: {},
        selected: true,
        default: false,
        value: "",
        options: ""
      });
      this.field.index = this.form.user_data_fields.length - 1;
    },

    editOptions(index) {
      this.field.index = index;
      const isCollectionField = this.currentField(
        this.form.user_data_fields[this.field.index].field_type_id
      );

      if (isCollectionField) {
        this.editField(this.field.index);
      } else {
        this.form.user_data_fields[this.field.index].options = "";
      }
    },

    currentField(filedId) {
      return this.fieldTypesWithOptions.find(ftw => ftw.id === filedId);
    },

    editField(index) {
      this.field.index = index;
      const optionsExist =
        this.form.user_data_fields[index] &&
        this.form.user_data_fields[index].meta_data &&
        this.form.user_data_fields[index].meta_data.options;
      if (optionsExist) {
        this.field.options = this.form.user_data_fields[
          index
        ].meta_data.options.join(",");
      } else {
        this.field.options = "";
      }

      this.showEditFieldOptions = true;
    },

    saveOptions() {
      if (this.applicationCode.length > 0) {
        return false;
      }
      const { index, options } = this.field;
      this.form.user_data_fields[index].meta_data = {
        options: options.replaceAll(", ", ",").split(",")
      };
      this.showEditFieldOptions = false;
    },

    removeField(index) {
      this.form.user_data_fields.splice(index, 1);
    },

    labelToKey(label) {
      return label.toLocaleLowerCase().replace(/ /gi, "_");
    },

    clearForm() {
      this.form = defaultForm();
    },

    preview(action) {
      if (action === "ui") {
        const payload = JSON.parse(JSON.stringify(this.form));
        const keys = ["created_at", "code", "id", "modified_at"];
        keys.forEach(key => {
          delete payload[key];
        });
        delete payload.customization.company_logo;
        delete payload.customization.company_logo_id;

        this.appDataPreview = payload;
        this.showWidgetPreview = true;
      } else {
        this.saveToSandbox();
      }
    },

    saveToSandbox() {
      this.previewing = true;
      this.$refs.authXForm.validate(async valid => {
        if (!valid) {
          this.saving = false;
          return false;
        }

        const payload = JSON.parse(JSON.stringify(this.form));
        const keys = ["created_at", "code", "id", "modified_at"];
        keys.forEach(key => {
          delete payload[key];
        });
        delete payload.customization.company_logo;
        delete payload.customization.company_logo_id;

        this.$http
          .post(
            `apps/${this.appId}/sandbox/configuration`,
            {
              body: {
                configuration: payload
              },
              method: "POST"
            },
            {
              headers: {
                "data-baseurl-namespace": apiConstants.URLS.AUTHX
              }
            }
          )
          .then(response => {
            this.previewing = false;
            const resData = response.data;
            if (resData.status === "error") {
              this.handleErrors(resData);
            } else {
              const route = this.$router.resolve({
                name: "authx.preview.index",
                params: { id: this.appId }
              });
              window.open(route.href, "_blank");
            }
          })
          .catch(() => {
            this.notification("Error", "An unknown error occurred", "danger");
            this.previewing = false;
          });
      });
    },

    save() {
      this.saving = true;
      this.$refs.authXForm.validate(async valid => {
        if (!valid) {
          this.saving = false;
          return false;
        }

        const confirmMsg = !this.appId
          ? "Additional fields cannot be edited, are you sure of the configuration to be saved?"
          : "Are you sure of the configuration to be saved?";

        this.$confirm(confirmMsg, "Warning", {
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning"
        })
          .then(() => {
            let apiUrl = "apps";
            let httpVerb = "POST";
            if (this.appId) {
              apiUrl += `/${this.appId}`;
              httpVerb = "PUT";
            }

            const payload = JSON.parse(JSON.stringify(this.form));
            delete payload.customization.company_logo;
            delete payload.customization.company_logo_id;

            this.$http
              .post(
                apiUrl,
                {
                  body: payload,
                  method: httpVerb
                },
                {
                  headers: {
                    "data-baseurl-namespace": apiConstants.URLS.AUTHX
                  }
                }
              )
              .then(response => {
                this.saving = false;
                const resData = response.data;
                if (resData.status === "error") {
                  this.handleErrors(resData);
                } else {
                  this.notification(
                    "Completed",
                    `Application ${
                      this.appId ? "updated" : "created"
                    } successfully`,
                    "success"
                  );
                  this.setAppData(resData);
                  if (!this.appId) {
                    const oauthClient = {
                      appId: resData.id,
                      id: resData.development.oauth.identifier,
                      secret: resData.development.oauth.secret,
                      appCode: resData.code
                    };
                    this.$emit("showApiToken", oauthClient);
                    this.applicationCode = resData.code;
                    this.appId = resData.id;

                    if (this.company_logo_file) {
                      this.uploadLogo(this.company_logo_file);
                    }
                  }
                }
              })
              .catch(() => {
                this.notification(
                  "Error",
                  "An unknown error occurred",
                  "danger"
                );
                this.saving = false;
              });
          })
          .catch(() => {
            this.saving = false;
          });
      });
    },

    resetClientSecret() {
      this.resetting = true;
      const confirmMsg =
        "Are you sure you want to reset your Client Secret Key? the configuration to be saved?";

      this.$confirm(confirmMsg, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          this.$http
            .post(
              `apps/${this.appId}/oauth/secret/reset`,
              {
                method: "PUT"
              },
              {
                headers: {
                  "data-baseurl-namespace": apiConstants.URLS.AUTHX
                }
              }
            )
            .then(response => {
              this.resetting = false;
              const resData = response.data;
              if (resData.status === "error") {
                this.handleErrors(resData);
              } else {
                this.notification(
                  "Completed",
                  "Client Secret reset successful",
                  "success"
                );
                this.newClientSecret = resData.secret;
              }
            })
            .catch(() => {
              this.notification("Error", "An unknown error occurred", "danger");
              this.resetting = false;
            });
        })
        .catch(() => {
          this.resetting = false;
        });
    },

    copyNewSecret() {
      this.$message({
        message: "Client Secret Copied",
        type: "success"
      });
    },

    loadVerificationTypes() {
      verificationTypes(this.$http)
        .then(res => {
          this.verificationTypes = res;
        })
        .catch(err => {
          this.notification("Error", err.message, "danger");
        });
    },

    loadFieldTypes() {
      fieldTypes(this.$http)
        .then(res => {
          this.fieldTypes = res;
          const textFieldType = this.textFieldType;
          const collectionType = this.collectionType;
          this.fieldTypesText = this.fieldTypes.filter(
            ft => ft.is_identifier_type === textFieldType
          );
          this.fieldTypesWithOptions = this.fieldTypes.filter(
            ft => ft.is_collection_type === collectionType
          );
        })
        .catch(err => {
          this.notification("Error", err.message, "danger");
        });
    },

    loadAppInfo(id) {
      this.loading = true;
      const apiUrl = `apps/${id}`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.loading = false;
          } else {
            this.form = defaultForm();
            const { name, description, customization, development } = resData;
            this.form.name = name;
            this.form.description = description;
            this.form.customization = {
              company_name: customization.company_name,
              meta_data: {
                primary_color: customization.meta_data.primary_color,
                secondary_color: customization.meta_data.secondary_color
              }
            };
            this.form.development = {
              domain: development.domain,
              oauth: {
                redirect_uri: development.oauth.redirect_uri,
                is_spa: development.oauth.is_spa
              }
            };
            this.loading = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    },

    loadApp(showLoading) {
      this.loading = showLoading;
      const apiUrl = `apps/${this.appId}`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET"
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.loading = false;
          } else {
            this.setAuthxApp(resData);
            this.setAppData(resData);
            this.loading = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    },

    setAuthxApp(data) {
      this.$store.commit(mutations.SET_AUTHX_APP, data);
    },

    setAppData(data) {
      this.form = data;
      this.googleAuth = !!this.form.user_auth_types.google;
      this.facebookAuth = !!this.form.user_auth_types.facebook;
      this.applicationCode = this.form.code;
      this.domainMetaData = {
        appCode: this.form.code,
        referer: this.form.development && this.form.development.domain,
        refererRedirectUrl:
          this.form.development &&
          this.form.development.oauth &&
          this.form.development.oauth.redirect_uri
      };
      this.is_enabled = data.status_id;

      if (this.action === "edit") {
        this.$emit("showApiToken", {
          appCode: this.applicationCode,
          clientId: this.form.development.oauth.identifier,
          isSpa: this.form.development.oauth.is_spa,
          redirectUri: this.form.development.oauth.redirect_uri
        });
      }

      setTimeout(() => {
        this.formEdited = false;
      }, 500);
    },
    uploadLogo(file) {
      if (!this.appId) {
        this.company_logo_file = file;
        return;
      }

      const formData = new FormData();

      formData.append("name", this.form.customization.company_name);
      formData.append("file", file);

      const apiUrl = `apps/${this.appId}/company/logo`;
      this.$http
        .post(apiUrl, formData, {
          headers: {
            "data-baseurl-namespace": apiConstants.URLS.AUTHX,
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.notification(
              "Completed",
              "Logo updated successfully",
              "success"
            );
            this.form.customization.company_logo = resData.url;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.uploading = false;
        });
    }
  },

  mounted() {
    if (this.action === "edit") {
      this.appId = this.$route.params.id;
      this.loadApp(true);
    } else if (this.action === "duplicate") {
      const { id } = this.$route.params;
      this.loadAppInfo(id);
    }

    if (this.userCan("authx", "global.getfieldtypes")) {
      this.loadFieldTypes();
    }

    if (this.userCan("authx", "global.getverificationtypes")) {
      this.loadVerificationTypes();
    }

    const params = this.$route.params;
    if (params.preview) {
      this.$refs.footer.$el.scrollIntoView({ behavior: "smooth" })
    }
  },

  watch: {
    googleAuth(val) {
      if (val) {
        this.form.user_auth_types.google = {};
      } else {
        delete this.form.user_auth_types.google;
      }
    },

    facebookAuth(val) {
      if (val) {
        this.form.user_auth_types.facebook = {};
      } else {
        delete this.form.user_auth_types.facebook;
      }
    },

    form: {
      deep: true,
      handler() {
        this.formEdited = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.code-link {
  cursor: pointer;
  color: var(--ra-primary);
  text-decoration: underline;
}

.social-logo {
  display: flex;
  align-items: center;

  img {
    height: 24px;
    width: 24px;
    margin-right: 5px;
  }
}

.authx-form {
  max-width: 1024px;
  margin: 0 auto 50px;
  padding: 40px !important;

  .authx-form-section {
    margin-bottom: 40px;
    flex-wrap: wrap;
  }

  .heading {
    margin-bottom: 50px;

    h5 {
      font-size: 1.25rem;
    }

    p {
      font-size: 0.875rem;
      font-weight: 400;
      margin-top: 10px;
    }
  }
}

.compulsory_fields {
  background: rgba(20, 8, 5, 0.04);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 15px;

  h6 {
    margin-bottom: 10px;
    font-size: 0.875rem;
  }

  p {
    font-size: 0.875rem;
  }
}

.field__add {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0 10px;

  p {
    cursor: pointer;
    color: var(--primary);
    font-size: 0.875rem;
    line-height: 1;
  }

  i {
    margin-right: 5px;
    color: var(--primary);
  }
}

.field__action {
  display: flex;
  justify-content: flex-end;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 22px;
    width: 22px;
    border-radius: 1000px;
    background: rgba(20, 8, 5, 0.06);

    i {
      font-weight: bold;
      font-size: 14px;
    }
  }

  div:last-child {
    margin-left: 14px;
  }
}

.field__remove {
  cursor: pointer;
}

.temp-hide {
  display: none;
}

.field__note {
  padding: 20px;
  background: rgba(20, 8, 5, 0.02);

  p {
    opacity: 0.74;
  }

  pre {
    line-height: 1px;
    margin-bottom: 0;
  }
}

.client-secret {
  display: flex;
  align-items: center;

  p {
    font-weight: 500;
    font-size: 1rem !important;
    width: 250px;
    margin-right: 10px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .copy {
    cursor: pointer;
    padding: 12px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #eee;

    i {
      font-size: 1rem;
      font-weight: 500;
      color: var(--ra-red-primary);
    }
  }
}

.logo-label {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--ra-grey-tertiary);
  display: flex;
  align-items: flex-start;
  line-height: 1;

  i {
    margin-left: 3px;
  }
}

.save-info {
  padding: 20px;
  background: rgba(20, 8, 5, 0.02);
  margin-bottom: 20px;

  p {
    margin-bottom: 10px;
    span {
      font-weight: 600;
      display: inline-block;
      width: 80px;
    }
  }
}
</style>
